import { render, staticRenderFns } from "./FxSpot.vue?vue&type=template&id=976de826&scoped=true"
import script from "./FxSpot.vue?vue&type=script&lang=js"
export * from "./FxSpot.vue?vue&type=script&lang=js"
import style0 from "./FxSpot.vue?vue&type=style&index=0&id=976de826&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "976de826",
  null
  
)

export default component.exports